import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TeamPill, UserPill } from 'components/Pill';
import InlineList from 'components/InlineList';
function TeamsAndUsersList(_ref) {
  var onRemoveTeam = _ref.onRemoveTeam,
    onRemoveUser = _ref.onRemoveUser,
    teams = _ref.teams,
    users = _ref.users;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs"
  }, [].concat(_toConsumableArray(teams.map(function (team) {
    var id = team.id,
      name = team.name;
    var deleteProps = onRemoveTeam ? {
      onDelete: function onDelete() {
        return onRemoveTeam(id);
      },
      deleteLabel: t('actions_remove_team', {
        name: name
      })
    } : {};
    return /*#__PURE__*/React.createElement(TeamPill, _extends({
      key: id,
      team: team
    }, deleteProps));
  })), _toConsumableArray(users.map(function (user) {
    var id = user.id,
      name = user.name;
    var deleteProps = onRemoveUser ? {
      onDelete: function onDelete() {
        return onRemoveUser(id);
      },
      deleteLabel: t('actions_remove_user', {
        name: name
      })
    } : {};
    return /*#__PURE__*/React.createElement(UserPill, _extends({
      key: id,
      user: user
    }, deleteProps));
  }))));
}
export default TeamsAndUsersList;